import $ from 'jquery';

// 親子チェックボックス制御
export const parentChildCheckbox = () => {
    // 親のチェックボックスが変更されたら、子のチェックボックスを変更する
    document.querySelectorAll('.c-others-search-list [data-parent] input[type="checkbox"]').forEach((obj) => {
        obj.addEventListener('change', (e) => {
            const checked = e.currentTarget.checked;
            e.currentTarget.closest('[data-block]').querySelectorAll('[data-child] input[type="checkbox"]').forEach((child) => {
                child.checked = checked;
                child.disabled = true;
            });
        });
    });

    // 子のチェックボックスが変更されたら、親のチェックボックスを変更する
    document.querySelectorAll('.c-others-search-list [data-child] input[type="checkbox"]').forEach((obj) => {
        obj.addEventListener('change', (e) => {
            const checked = e.currentTarget.checked;
            if (!checked) {
                if (e.currentTarget.closest('[data-block]').querySelector('[data-parent] input[type="checkbox"]')) {
                    e.currentTarget.closest('[data-block]').querySelector('[data-parent] input[type="checkbox"]').checked = checked;
                }
            }
        });
    });

    // 子のチェックボックスがクリックされたら、兄弟要素の子チェックボックスを有効化する
    document.querySelectorAll('.c-others-search-list [data-child] .c-forms-checkbox').forEach((obj) => {
        obj.addEventListener('click', (e) => {
            e.currentTarget.closest('[data-block]').querySelectorAll('[data-child] input[type="checkbox"]').forEach((child) => {
                child.disabled = false;
            });
        });
    });


    document.querySelectorAll('.c-others-search-list [data-block].js-accordion label').forEach((obj) => {
        obj.addEventListener('click', (e) => {
            e.stopPropagation();
        });
    });
}

// 初期表示時の処理
const initial = () => {
    // 初期表示時に親がチェックされている場合、子をすべてチェック＋無効化する
    document.querySelectorAll('.c-others-search-list [data-parent] input[type="checkbox"]').forEach((obj) => {
        if (obj.checked) {
            obj.closest('[data-block]').querySelectorAll('[data-child] input[type="checkbox"]').forEach((child) => {
                child.disabled = true;
                child.checked = obj.checked;
            });
        }
    });

    // アコーディオン要素で初期でチェックボックスがチェックされていたらアコーディオンを開いておく
    document.querySelectorAll('.c-others-search-list [data-block].js-accordion').forEach((obj) => {
        if (obj.querySelector('[data-parent] input[type="checkbox"]').checked) {
            obj.dataset.open = '';
        }
        if (obj.querySelector('[data-child] input[type="checkbox"]:checked')) {
            obj.dataset.open = '';
        }
    });
}

const main = () => {
    if (document.querySelector('.c-others-search-list') === null) return;

    // 戻るボタン対応のため遅延させる
    setTimeout(() => {
        initial();
    }, 400);

    parentChildCheckbox();
}

export default main
